import {get, put,patch} from '@/api/request.js'

const url = '/admin/influence/factor'

/**
 * 获取未选择的影响因素
 * @returns {Promise<void>}
 */
export const get_influence_factor = async function (page, page_size) {
    return await get(url, {
        params: {page, page_size}
    })
}

/**
 * 修改影响因素
 * @returns {Promise<void>}
 */
export const put_influence_factor = async function (data) {
    return await patch(url, {
        data: data
    })
}


/**
 * 修改未选择的影响因素
 * @param {Array}ids id列表
 * @param {number}influence_factor 影响因素
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_intelligent_wizard = async function (ids, influence_factor) {
    return await put(url, {
        data: {
            ids, influence_factor
        }
    })
}
